module.exports = __webpack_public_path__ + "img/BP.6fc25061.png";